<div
  class="filter-buttons gap-x-2"
  [ngClass]="{ 'position-right': position === 'right', 'is-mobile': mobile }"
>
  <app-shared-button
    theme="outline"
    size="small"
    #resetButton
    (click)="handleReset(resetButton)"
    *ngIf="!hideReset"
  >
    {{ resetLabel || (mobile ? 'Reset all' : 'Reset') }}
  </app-shared-button>

  <div *ngIf="hideReset && showEmptySpace" class="flex-1">&nbsp;</div>

  <app-shared-button
    #applyButton
    (click)="handleApply(applyButton)"
    size="small"
  >
    Apply
  </app-shared-button>
</div>
